import { useMemo } from 'react'

import empty_dark from '@/assets/empty-dark.png'
import empty_light from '@/assets/empty-light.png'
import { useLocalStorage } from '@/context/localstorage-context'

export default function EmptyData({ text }: { text: string }) {
  const { theme } = useLocalStorage()
  const isDark = useMemo(() => theme === 'dark', [theme])
  return (
    <div className="w-full flex flex-col gap-4 justify-center items-center border-1 border-light-555 dark:border-dark-666 py-4 rounded-2xl min-h-[400px]">
      <img
        src={isDark ? empty_dark : empty_light}
        alt="empty"
        className="mt-[20px]"
        width={100}
      />
      <div className="max-w-[200px] text-[12px] mt-[10px] bg-light-104 rounded-4xl py-4 px-6 dark:bg-dark-888 dark:text-dark-111">
        {text}
      </div>
    </div>
  )
}
